<template>
    <div>
        <VJoyLabel v-if="projectInformation.currentDatetime">Current project date: {{ formatDate(projectInformation.currentDatetime) }}</VJoyLabel>
        <MaltDatePicker key="startDate" v-model="selectedDate" name="startDate" :min-date="minimumDate" />

        <VJoyWrapper justify="flex-end">
            <VJoyHighlight level="warning">
                Time travel can only done to the future. You cannot go back to a past date. Be careful when you change the new date as it's
                irreversible.
            </VJoyHighlight>
            <VJoyButton :loading="loading" @click="triggerTimeTravel">Time travel (irreversible)</VJoyButton>
        </VJoyWrapper>
    </div>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {addDays, subDays} from 'date-fns';
    import {storeToRefs} from 'pinia';
    import {MaltDatePicker} from '#components';
    import {useFormat} from '#imports';
    import {VJoyButton, VJoyHighlight, VJoyLabel, VJoyWrapper} from '@maltjoy/core-vue';
    import {useProjectInformationStore} from '~/common/stores';

    const loading = ref(false);

    const {formatDate} = useFormat();

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);

    const minimumDate = computed(() => {
        if (projectInformation.value.currentDatetime) {
            return addDays(projectInformation.value.currentDatetime, 1);
        }
        return addDays(new Date(), 1);
    });

    const selectedDate = ref<Date>(subDays(minimumDate.value, 1));

    async function triggerTimeTravel() {
        try {
            loading.value = true;
            await projectInformationStore.timeTravelProject(selectedDate.value);
            window.location.reload();
        } catch (e) {
            console.error(e);
        } finally {
            loading.value = false;
        }
    }
</script>
